import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@padspin/ui-marketing-icons';

interface CityEntry {
  state: string;
  cities: string;
}

const CITIES: CityEntry[] = [
  { state: 'Arizona', cities: 'Phoenix' },
  { state: 'California', cities: 'Los Angeles · San Diego · SF' },
  { state: 'Colorado', cities: 'Denver' },
  { state: 'Florida', cities: 'Miami · Orlando' },
  { state: 'Georgia', cities: 'Atlanta' },
  { state: 'Illinois', cities: 'Chicago' },
  { state: 'Massachusetts', cities: 'Boston' },
  { state: 'New York', cities: 'New York City' },
  { state: 'Oregon', cities: 'Portland' },
  { state: 'Pennsylvania', cities: 'Philadelphia' },
  { state: 'Texas', cities: 'Austin' },
  { state: 'Washington', cities: 'Seattle' },
];

@Component({
  selector: 'padspin-marketing-cities-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <section id="cities" class="bg-gradient-soft py-24 sm:py-32">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p
            class="text-sm font-semibold uppercase tracking-wider text-brand-blue-700"
          >
            Locations
          </p>
          <h2
            class="mt-3 text-4xl font-bold tracking-tight text-color sm:text-5xl"
          >
            Live in
            <span class="text-gradient-brand">12 major U.S. cities</span>
          </h2>
          <p class="mt-4 text-lg text-muted-color">More cities coming soon.</p>
        </div>

        <div
          class="mt-16 grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        >
          @for (c of cities; track c.state) {
            <div
              class="flex items-start gap-3 rounded-xl border border-surface bg-surface-0 dark:bg-surface-900 p-4 shadow-card transition-smooth hover:border-brand-green-500/40"
            >
              <padspin-icon
                name="map-pin"
                [size]="20"
                class="mt-0.5 text-brand-green-700"
              />
              <div>
                <div
                  class="text-xs font-semibold uppercase tracking-wider text-muted-color"
                >
                  {{ c.state }}
                </div>
                <div class="text-sm font-medium text-color">
                  {{ c.cities }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class MarketingCitiesSectionComponent {
  protected readonly cities = CITIES;
}
